// Small helpers shared by the TT Options Trader v2 (paper) pages.

export const MULTIPLIER: Record<string, number> = { SPX: 100, SPXW: 100, SPY: 100, QQQ: 100, IWM: 100, ES: 50, MES: 5, NQ: 20, MNQ: 2, GC: 100, CL: 1000 };

export const STRATEGY_LABELS: Record<string, string> = {
  naked_put: 'Put',
  bear_call_spread: 'Bear Call Spread',
  jade_lizard: 'Jade Lizard',
  iron_condor: 'Iron Condor',
};

/** Human label for an engine's strategy + tradeType (v1's card showed every multi-leg strategy as "Spread"). */
export function strategyLabel(strategy?: string, tradeType?: string, spreadWidth?: number | null): { label: string; color: string } {
  if (strategy === 'bear_call_spread') return { label: 'Bear Call Spread', color: '#a855f7' };
  if (strategy === 'jade_lizard') return { label: 'Jade Lizard', color: '#f59e0b' };
  if (strategy === 'iron_condor') return { label: 'Iron Condor', color: '#22d3ee' };
  if (tradeType === 'naked') return { label: 'Naked Put', color: '#f59e0b' };
  if (tradeType === 'auto') return { label: `Auto ${spreadWidth || 50}pt`, color: '#3b82f6' };
  return { label: `Put Spread ${spreadWidth || 50}pt`, color: '#f9fafb' };
}

export const maskAcct = (n?: string | null) => (n ? '***' + String(n).slice(-4) : '-');

/** v2 engines carry no name; same fallback as the API's engineName ("ES iron condor #ab12"). */
export function engineDisplayName(e: { name?: string; engineName?: string | null; symbol?: string; strategy?: string; engineId?: string; engineType?: string }): string {
  const n = e.name || e.engineName;
  if (n) return n;
  if (e.engineType === 'manual' || e.strategy === 'manual') return `Manual #${String(e.engineId || '').slice(-4)}`;
  return `${e.symbol || '?'} ${String(e.strategy || '').replace(/_/g, ' ')} #${String(e.engineId || '').slice(-4)}`.trim();
}

/** YYYY-MM-DD of an instant in America/New_York. */
export function etDate(d: Date | string): string {
  const dt = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(dt.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(dt);
  const get = (t: string) => parts.find(p => p.type === t)?.value || '';
  return `${get('year')}-${get('month')}-${get('day')}`;
}
